import { render, staticRenderFns } from "./FormWrap.vue?vue&type=template&id=a64fda98&scoped=true&"
import script from "./FormWrap.vue?vue&type=script&lang=ts&"
export * from "./FormWrap.vue?vue&type=script&lang=ts&"
import style0 from "./FormWrap.vue?vue&type=style&index=0&id=a64fda98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64fda98",
  null
  
)

export default component.exports